import { render, staticRenderFns } from "./contentTable.vue?vue&type=template&id=de51142a&scoped=true"
import script from "./contentTable.vue?vue&type=script&lang=js"
export * from "./contentTable.vue?vue&type=script&lang=js"
import style0 from "./contentTable.vue?vue&type=style&index=0&id=de51142a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de51142a",
  null
  
)

export default component.exports